import { timer } from '../../Common/Timer';

const timerElements = document.querySelectorAll('.timer');
timerElements.forEach((timerElement) => {
    const id = timerElement.getAttribute('id');
    const carbonDate = timerElement.getAttribute('data-carbonDate');
    if (id && carbonDate) {
        timer(id, carbonDate, [torunamentTimerCallback]);
    }
});

export function torunamentTimerCallback(id: string) {
    const timerElement = document.getElementById(id);

    if (timerElement) {
        timerElement.style.display = 'none';

        const tournamentBlockElement = timerElement.parentElement as HTMLElement;
        if (tournamentBlockElement) {
            tournamentBlockElement.style.display = 'none';

            const tournamentCountdownFinishedElement = tournamentBlockElement.parentElement?.querySelector(
                '.tournament-countdown-finished'
            ) as HTMLElement;
            if (tournamentCountdownFinishedElement) {
                tournamentCountdownFinishedElement.style.display = 'block';
            }
        }
    }
}
